var exports = {
  "Kk": "CallMessage.module__icon___V0VJal",
  "mR": "CallMessage.module__iconActive___V0VJal",
  "Ap": "CallMessage.module__iconEnded___V0VJal",
  "bp": "CallMessage.module__iconMissed___V0VJal",
  "x": "CallMessage.module__callLink___V0VJal",
};

module.exports = exports;
